import React from 'react';
import Dialog from 'material-ui/Dialog';
import IconButton from 'material-ui/IconButton';
import NavigationClose from 'material-ui/svg-icons/navigation/close';

/* eslint-disable */
class Popup extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			visible: !sessionStorage.getItem('@samesame_booking_popup_close'),
        };
        
        this.handleClose = this.handleClose.bind(this);
        this.handleHTMLClick = this.handleHTMLClick.bind(this);
    }
    
    handleClose() {
        this.setState({ visible: false });
        sessionStorage.setItem('@samesame_booking_popup_close', 'true');
      };

    handleHTMLClick(e) {
        if (e && e.target && e.target.getAttribute && e.target.getAttribute('href') === '#close') {
            if (e.preventDefault) {
                e.preventDefault();
            }    
            this.handleClose();
        }
    }

	render() {
		return (
            <Dialog
                open={this.state.visible}
                autoScrollBodyContent
                onRequestClose={this.handleClose}
                bodyStyle={{
                    backgroundColor: '#DBD0BE',
                }}
            >
                <div
                    className="booking-popup-body"
                    style={{
                        color: '#132F17',
                        fontFamily: 'Apercu Mono Regular',
                        lineHeight: 2,
                        textAlign: 'center',
                        fontSize: 14,
                    }}
                >
                    <div
                        className="body-html-box"
                        onClick={this.handleHTMLClick}
                        dangerouslySetInnerHTML={{ __html: this.props.body }}
                    />
                </div>
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                    }}
                >
                    <IconButton onClick={this.handleClose}>
                        <NavigationClose />
                    </IconButton>
                </div>
            </Dialog>
		);
	}
}

export default Popup;



// WEBPACK FOOTER //
// ./src/Theme/Popup.jsx